import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "contact-container" }
const _hoisted_2 = { class: "main-title" }
const _hoisted_3 = { class: "bg-text" }
const _hoisted_4 = { class: "contact-content-con" }
const _hoisted_5 = { class: "left-contact" }
const _hoisted_6 = { class: "contact-info" }
const _hoisted_7 = { class: "icon" }
const _hoisted_8 = { style: {"font-size":"12px"} }
const _hoisted_9 = { style: {"font-size":"10px"} }
const _hoisted_10 = { class: "contact-icons" }
const _hoisted_11 = { class: "contact-icon" }
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "right-contact" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("input", {
  type: "hidden",
  name: "form-name",
  value: "contact"
}, null, -1)
const _hoisted_15 = { class: "input-control i-c-2" }
const _hoisted_16 = ["placeholder"]
const _hoisted_17 = ["placeholder"]
const _hoisted_18 = { class: "input-control" }
const _hoisted_19 = ["placeholder"]
const _hoisted_20 = { class: "input-control" }
const _hoisted_21 = ["placeholder"]
const _hoisted_22 = ["disabled"]
const _hoisted_23 = {
  key: 0,
  class: "text-green-500"
}
const _hoisted_24 = {
  key: 1,
  class: "text-red-500"
}
const _hoisted_25 = { class: "p-2" }

import { ref } from 'vue';
import CV from '@/components/DownloadCV.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Contact',
  setup(__props) {

const formData = ref({
  name: '',
  email: '',
  subject: '',
  message: ''
});

const success = ref(false);
const error = ref(false);
const loading = ref(false);

const handleSubmit = async () => {
  loading.value = true;
  success.value = false;
  error.value = false;

  const form = new FormData();
  form.append('form-name', 'contact');
  form.append('name', formData.value.name);
  form.append('email', formData.value.email);
  form.append('subject', formData.value.subject);
  form.append('message', formData.value.message);

  try {
    const response = await fetch('/', {
      method: 'POST',
      body: form
    });

    if (response.ok) {
      success.value = true;
      formData.value = { name: '', email: '', subject: '', message: '' };
    } else {
      error.value = true;
    }
  } catch {
    error.value = true;
  } finally {
    loading.value = false;
  }
};

const contactItems = [
  { icon: "fas fa-map-marker-alt", label: "contact.location", info: ": Beja, Tunisia" },
  { icon: "fas fa-envelope", label: "contact.email", info: ": wissem.zeddini@esen.tn" },
  { icon: "fas fa-user-graduate", label: "contact.education", info: ": Higher school of digital economics of Tunisia" },
  { icon: "fas fa-mobile-alt", label: "contact.mobileNumber", info: "(+216) 25 960 738" },
  { icon: "fas fa-globe-africa", label: "contact.languages", info: ": French, English, Arabic" }
];

const socialIcons = [
  { icon: "fab fa-facebook-f", link: "https://www.facebook.com/Wissem.zeddini07/" },
  { icon: "fab fa-linkedin", link: "https://www.linkedin.com/in/wissem-zeddini-3829b4179/" },
  { icon: "fab fa-twitter", link: "#" },
  { icon: "fab fa-github", link: "https://github.com/Wissemzeddini" },
  { icon: "fab fa-youtube", link: "https://www.youtube.com/@elkhabir251" }
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h2", null, [
          _createTextVNode(_toDisplayString(_ctx.$t('contact.mainTitle')) + " ", 1),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('contact.subtitle')), 1),
          _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('contact.bgText')), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h4", null, _toDisplayString(_ctx.$t('contact.contactMeHere')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('contact.officialContact')), 1),
          _createElementVNode("div", _hoisted_6, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(contactItems, (item, index) => {
              return _createElementVNode("div", {
                key: index,
                class: "contact-item"
              }, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("i", {
                    class: _normalizeClass(item.icon)
                  }, null, 2),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.$t(item.label)), 1)
                ]),
                _createElementVNode("p", _hoisted_9, [
                  _createElementVNode("span", null, _toDisplayString(item.info), 1)
                ])
              ])
            }), 64))
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(socialIcons, (icon, index) => {
                return _createElementVNode("a", {
                  key: index,
                  href: icon.link,
                  target: "_blank"
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(icon.icon)
                  }, null, 2)
                ], 8, _hoisted_12)
              }), 64))
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("form", {
            class: "contact-form",
            name: "contact",
            netlify: "",
            "data-netlify": "true",
            onSubmit: _withModifiers(handleSubmit, ["prevent"])
          }, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.name) = $event)),
                required: "",
                placeholder: _ctx.$t('contact.namePlaceholder'),
                name: "name"
              }, null, 8, _hoisted_16), [
                [_vModelText, formData.value.name]
              ]),
              _withDirectives(_createElementVNode("input", {
                type: "email",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.email) = $event)),
                required: "",
                placeholder: _ctx.$t('contact.emailPlaceholder'),
                name: "email"
              }, null, 8, _hoisted_17), [
                [_vModelText, formData.value.email]
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.subject) = $event)),
                required: "",
                placeholder: _ctx.$t('contact.subjectPlaceholder'),
                name: "subject"
              }, null, 8, _hoisted_19), [
                [_vModelText, formData.value.subject]
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _withDirectives(_createElementVNode("textarea", {
                name: "message",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.message) = $event)),
                required: "",
                cols: "15",
                rows: "8",
                placeholder: _ctx.$t('contact.messagePlaceholder')
              }, null, 8, _hoisted_21), [
                [_vModelText, formData.value.message]
              ])
            ]),
            _createElementVNode("button", {
              type: "submit",
              class: "sub-btn",
              disabled: loading.value
            }, _toDisplayString(loading.value ? _ctx.$t('contact.sending') : _ctx.$t('contact.sendButton')), 9, _hoisted_22),
            (success.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(_ctx.$t('contact.successMessage')), 1))
              : _createCommentVNode("", true),
            (error.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(_ctx.$t('contact.errorMessage')), 1))
              : _createCommentVNode("", true)
          ], 32)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_25, [
      _createVNode(CV)
    ])
  ], 64))
}
}

})